module.exports = __webpack_public_path__ + "static/img/Bachelor_010587.c370ea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010587.jpg
// module id = 194
// module chunks = 0